import { createFileRoute, redirect } from '@tanstack/react-router';
import { supabase } from '@/lib/supabase';
import { sessionRole } from '@/lib/sessionRole';

// Root index: if logged in, send to role-appropriate dashboard.
// Unauthenticated → login.

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession();
    if (!data.session) {
      throw redirect({ to: '/login' });
    }
    const role = sessionRole(data.session) ?? 'parent';
    const dest =
      role === 'admin'
        ? '/admin'
        : role === 'faculty'
          ? '/faculty'
          : role === 'dancer'
            ? '/dancer'
            : '/parent';
    throw redirect({ to: dest });
  },
});
